/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { DeviceFeatures } from "../../device";
import type { IServiceControlledFeatureProvider } from "../../interfaces";
import type { TServiceFeatureMapping } from "../types";

/**
 * DeviceFeatures source for SERVICE_CONTROLLED features. Reads the synchronous,
 * in-memory device-feature state; returns `null` before device features load so
 * the resolver can fall back to cached state.
 */
export class DeviceFeatureSource implements IServiceControlledFeatureProvider {
  public getFeatureState(mapping: TServiceFeatureMapping): boolean | null {
    if (mapping.featureName === undefined || mapping.featureName === "") {
      return null;
    }
    return DeviceFeatures.getServiceFeatureState(
      mapping.featureName,
      mapping.attributeName
    );
  }
}
